<template>
  <nav>
    <AlertMessages
      v-if="alertValue"
      :alert-type="alertType"
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <v-row no-gutters>
      <v-col
        :cols="mobile() ? '12' : '11'"
        :class="mobile() ? '' : 'mx-auto'"
      >
      <TopSpacePeople page="boosters"/> 
      </v-col>
      <v-col
        :cols="mobile() ? '12' : '11'"
        :class="mobile() ? ' mx-auto d-flex justify-end' : 'mx-auto'"
      >
        <SearchBarExpanding v-if="!(users && users.length == 0 && usersInfo.currentPage == 1 && !loadingData && !loadingClear && search == null && startDateFilter == null && endDateFilter == null)" @input="searchPeople" @resetSearch="resetSearch"/>
      </v-col>
      <v-col
        :cols="mobile() ? '12' : '11'"
        class="mx-auto d-flex align-right justify-end mt-6"
      >
        <DateFilterPeople v-if="!loadingData" @dateFilter="dateFilter"/>
      </v-col>
    </v-row>
     <v-row
      v-if="users && !loadingData"
      align="center"
      class="mx-auto"
      :class="mobile() ? 'pa-3' : ''"
    >
      <v-col
        :cols="mobile() ? '12' : '11'"
        class="mx-auto px-0"
      >
        <v-card
          v-for="user in users"
          :key="user.id"
          rounded="xl"
          class="my-2 solo"
        >
          <v-hover v-if="mobile()">
            <v-row
              v-if="mobile()"
              slot-scope="{ hover }"
              no-gutters
              :class="`py-3 elevation-${hover? 8 : 2 }`"
            >
              <v-col 
                cols="11"
                class="d-flex justify-left align-center "
              >
                <v-avatar
                  size="38"
                  class="ml-4 mr-2"
                >
                  <img
                    v-if="user.attributes.avatar_thumb == null"
                    :src="defaultImage"
                  />
                  <img v-else :src="`${user.attributes.avatar_thumb}`" />
                </v-avatar>
                <div class="mail-name text-no-wrap text-truncate mr-4">
                  <v-card-text class="text-body-2 darktext--text pa-0 text-no-wrap text-truncate d-block">
                    {{ user.attributes.first_name }} {{ user.attributes.last_name }}
                  </v-card-text>
                  <v-card-text class="text-body-3 greytext--text pa-0 text-no-wrap text-truncate">
                    {{ user.attributes.email }} 
                  </v-card-text>
                </div>
              </v-col>
              <v-col
                cols="1"
                class="text-right d-flex align-center justify-end three-dots"
              >
                <v-menu
                v-if="userSpaceId != user.id && (role == 'space_admin' || role == 'booster')"
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-1"
                      icon
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon
                        large
                        data-testid="threedots-icon"
                      >
                        mdi-dots-vertical
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                    v-if="userSpaceId != user.id && (role == 'space_admin' || role == 'booster')"
                      data-testid="view-profile"
                      router
                      @click.stop="
                        selectedRole = permissions[user.id],
                        viewedUser = user,
                        dialogVisibleViewProfile = true, 
                        confirmationDialogTitle = 'User profile'"
                    >
                      <v-list-item-title>{{ $t('viewUserProfile') }}</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                    v-if="(usersInfo.owner != user.id && role == 'space_admin') && (userSpaceId != user.id && role == 'space_admin')"
                      data-testid="edit-role"
                      router
                      @click.stop="
                        selectedRole = permissions[user.id],
                        userId = user.id,
                        dialogVisibleChooseRole = true, 
                        confirmationDialogTitle = $t('confirmationDialogTitleChooseRole'), 
                        confirmationDialogSubmitBtn = $t('save')
                        confirmationDialogCancelBtn = $t('cancel')"
                    >
                      <v-list-item-title>{{ $t('editRole') }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
          </v-hover>
          <v-hover v-if="!mobile()">
 
            <v-row
              v-if="!mobile()"
              slot-scope="{ hover }"
              no-gutters
              :class="`py-4 elevation-${hover? 8 : 2 }`"
            >
              <v-col
                md="1"
                align="center"
                class="d-flex justify-center align-center"
              >
                <v-avatar
                  size="38"
                  class="mx-2"
                >
                  <img
                    v-if="user.attributes.avatar_thumb == null"
                    :src="defaultImage"
                  >
                  <img
                    v-else
                    :src="`${user.attributes.avatar_thumb}`"
                  >
                </v-avatar>
              </v-col>

              <v-col
                md="3"
                lg="4"
                align="left"
              >
                <div class="text-body-2 grey--text justify-left">
                  {{ $t('name') }}
                </div>
                <div class="text-body-1 darktext--text">
                  {{ user.attributes.first_name }} {{ user.attributes.last_name }}
                </div>
              </v-col>

              <v-col
                md="3"
                align="left"
                class="pl-2"
              >
                <div class="text-body-2 grey--text justify-left">
                  {{ $t('mail') }}
                </div>
                <div class="text-body-1 darktext--text">
                  {{ user.attributes.email }}
                </div>
              </v-col>

              <v-col
                md="2"
                align="left"
                class="pl-2"
              >
                <div class="text-body-2 grey--text justify-left">
                  {{ $t('role') }}
                </div>
                <div
                  v-if="(usersInfo.owner != user.id) && (permissions[user.id] == 'Space Admin')"
                  class="text-body-1 darktext--text"
                >
                  {{ $t('booster') }}/{{ $t('spaceAdmin') }}
                </div>
                <div
                  v-else-if="permissions[user.id] == 'Booster'"
                  class="text-body-1 darktext--text"
                >
                  {{ $t('booster') }}
                </div>
                 <div
                  data-testid="space-owner"
                  v-else-if="(usersInfo.owner == user.id) && (permissions[user.id] == 'Space Admin')"
                  class="text-body-1 darktext--text"
                >
                  {{ $t('booster') }}/{{ $t('spaceOwner') }}
                </div>
              </v-col>
              <v-col 
                md="2" 
                lg="1" 
                align="left"
                class="pl-2"
              >
                <div class="text-body-2 grey--text justify-left">
                  {{ $t('lastLogin') }}
                </div>
                <div class="text-body-1 darktext--text">
                  {{ format_date(user.attributes.last_login_at) }}
                </div>
              </v-col>
              <v-col
                md="1"
                class="text-right d-flex align-center justify-end three-dots"
              >
                <v-menu offset-y v-if="userSpaceId != user.id && (role == 'space_admin' || role == 'booster')">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-4"
                      icon
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon
                        x-large
                        data-testid="threedots-icon"
                      >
                        mdi-dots-vertical
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                    v-if="userSpaceId != user.id && (role == 'space_admin' || role == 'booster')"
                      data-testid="view-profile"
                      router
                      @click.stop="
                        selectedRole = permissions[user.id],
                        viewedUser = user,
                        dialogVisibleViewProfile = true, 
                        confirmationDialogTitle = 'User profile'"
                    >
                      <v-list-item-title>{{ $t('viewUserProfile') }}</v-list-item-title>
                    </v-list-item>

                   <v-list-item
                   v-if="(usersInfo.owner != user.id && role == 'space_admin') && (userSpaceId != user.id && role == 'space_admin')"
                      data-testid="edit-role"
                      router
                      @click.stop="
                        selectedRole = permissions[user.id],
                        userId = user.id,
                        dialogVisibleChooseRole = true, 
                        confirmationDialogTitle = $t('confirmationDialogTitleChooseRole'), 
                        confirmationDialogSubmitBtn = $t('save')
                        confirmationDialogCancelBtn = $t('cancel')"
                    >
                      <v-list-item-title>{{ $t('editRole') }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
          </v-hover>
        </v-card>
      </v-col>
    </v-row>
  
    <ConfirmationDialogChooseRole
      v-if="dialogVisibleChooseRole"
      :visible="dialogVisibleChooseRole"
      :cd-title="confirmationDialogTitle"
      :cd-submit-btn="confirmationDialogSubmitBtn"
      :cd-cancel-btn="confirmationDialogCancelBtn"
      :loading="loading"
      :selected-role="selectedRole.toLowerCase().split(' ').join('_')"
      data-testid="confirmation-dialog-choose-role"
      @close="dialogVisibleChooseRole=false"
      @proceedSubmit="updateRole"
    />

    <ViewUserProfileDialog
      v-if="dialogVisibleViewProfile"
      :visible="dialogVisibleViewProfile"
      :cd-title="confirmationDialogTitle"
      :selected-role="selectedRole"
      :viewed-user="viewedUser"
      data-testid="view-user-profile-dialog"
      @close="dialogVisibleViewProfile=false"
    />
    
    <Pagination
      v-if="users.length > 0"
      v-model="pageNumber"
      class="mb-16"
      circle
      :data-length="usersInfo.total"
      :page-number="usersInfo.currentPage"
      total-visible="5"
      :size="size"
      @input="handlePageChange"
      :key="paginationKey"
    />

    <PlusButtonWithLink
      data-testid="invite-people-button"
      rounded="xl"
      :link="link"
    />
  </nav>
</template>
<script>
import i18n from '../../plugins/i18n'
import { getSpaceBoosters,updateRoleSpaceMember,searchInSpaceBoosters } from '../../api/spaceApi'
import Pagination from '../../components/Pagination'
import PlusButtonWithLink from '../../components/PlusButtonWithLink'
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'
import AlertMessages  from '../../components/AlertMessages'
import ConfirmationDialogChooseRole from '../../components/ConfirmationDialogChooseRole'
import ViewUserProfileDialog from '../../components/ViewUserProfileDialog'
import TopSpacePeople from './TopSpacePeople'
import SearchBarExpanding from '../../components/SearchBarExpanding'
import moment from 'moment'
import DateFilterPeople from '../../components/DateFilterPeople'

export default {
    components: {
        Pagination,
        PlusButtonWithLink,
        AlertMessages,
        ConfirmationDialogChooseRole,
        ViewUserProfileDialog,
        TopSpacePeople,
        SearchBarExpanding,
        DateFilterPeople
    },
    mixins: [repeatedMethodsMixin],
    data(){
        return{
            users: [],
            usersInfo: { 
                currentPage: 1,
                total: 0,
            },
            permissions: [],
            spaceId: window.$cookies.get('space_id'),
            role: localStorage.space ? JSON.parse(localStorage.space).role : '',
            error:'',
            alertMsg:'',
            alertValue:false,
            defaultImage: require('../../assets/user_images/profile-avatar.png'),
            pageNumber: 1,
            size: 15,
            link: {title: i18n.t('invitePeopleTitle'), route: '/audiences/invite'},
            confirmationDialogTitle: '',
            confirmationDialogText: '',
            confirmationDialogCancelBtn: '',
            confirmationDialogSubmitBtn: '',
            cdSubmitBtnColor:'',
            cdCancelBtnColor:'',
            loadingData: false,
            dialogVisibleChooseRole:false,
            userSpaceId:window.$cookies.get('id'),
            userId:'',
            loading:false,
            search: null,
            paginationKey: '',
            dialogVisibleViewProfile: false,
            totalUsers: 0,
            startDateFilter: null,
            endDateFilter: null,
            loadingClear: false
        }
    },
    computed: {
      productPlan() {
        return this.$store.state.productPlan;
      },
    },
    async created(){
        this.loadingData = true
        await this.fetchUsers()
        this.loadingData = false
    },
    methods:{
        async searchPeople(keyword){
          this.search = keyword
            if(keyword && keyword.trim().length >= 2){
              try {
                  const response = await searchInSpaceBoosters(this.spaceId,keyword,this.pageNumber, this.size, this.startDateFilter, this.endDateFilter)
                  if(response){
                      if(response.status == 200){
                          this.users = response.data.data
                          if(this.users.length == 0 && response.data.meta.total > 0){
                              this.pageNumber = 1
                              await this.searchPeople(keyword)
                          }else {
                              this.usersInfo = response.data.meta
                              if(this.pageNumber == 1){
                                this.paginationKey = Date.now()
                              }
                              window.scrollTo(0,0)
                          } 
                      }
                  }
              } catch (e) {
                  if(e.response){
                      this.error = true
                      this.alertType = 'error'
                      this.alertMsg =  i18n.t('serverError')
                      this.alertValue = true
                  } 
              }
            }
        },
        async resetSearch(){
          this.usersInfo.currentPage = 1
          this.pageNumber = 1
          await this.fetchUsers()
          this.search = null
          this.paginationKey = Date.now()
          return
        },
         handlePageChange(value){
            this.usersInfo.currentPage = value
            this.pageNumber = value
            if(this.search == null){
              this.fetchUsers()
            }else {
              this.searchPeople(this.search)
            }
        },
        async fetchUsers(){
            try {
                const response = await getSpaceBoosters(this.spaceId, this.pageNumber, this.size, this.startDateFilter, this.endDateFilter)
                if(response.status){
                    if(response.status == 200) {
                        this.users = response.data.data
                        this.permissions = response.data.meta.permissions
                        if(this.users.length == 0 && response.data.meta.total > 0){
                            this.pageNumber = 1
                            await this.fetchUsers()
                        }else {
                            this.usersInfo = response.data.meta
                            this.totalUsers = response.data.meta.total
                            if(this.pageNumber == 1){
                              this.paginationKey = Date.now()
                            }
                            window.scrollTo(0,0)
                        } 
                    }
                }
            } catch (e) {
                if(e.response){
                    this.alertValue = true
                    if(e.response.status == 403){
                        this.$router.push({name: 'PageAccessDenied'})
                    } else {
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                    }
                }
            }
        },
        async updateRole(role){
          this.loading=true
           try {
                let data = {
                    data: {
                         type: "spaces",
                          id: this.spaceId,
                          attributes: {
                            user_id: this.userId,
                            role: role,
                          }


                    }
                }
                const response = await updateRoleSpaceMember(this.spaceId,data) 
                if(response.status == 200) {
                  this.dialogVisibleChooseRole=false
                  this.alertValue = true
                  this.alertType = 'success'
                  this.alertMsg =  i18n.t('editRoleMsg')
                  if(this.search == null){
                      await this.fetchUsers()
                  }else {
                      await this.searchPeople(this.search)
                  }
                  this.$store.dispatch("getSpaceUsersStatistics", this.spaceId).catch(() => {
                      this.alertValue = true
                      this.alertType = 'error'
                      this.alertMsg =  i18n.t('serverError') 
                    
                  })
                }
            } catch (e) {
                if(e.response){
                    this.alertValue = true
                    this.alertType = 'error'
                    this.alertMsg =  i18n.t('serverError')
                }   
            }
            this.loading=false
        },
        format_date(value){
          if (value) {
            return moment(String(value)).format('YYYY-MM-DD')
          }
        },

        async dateFilter(startDate, endDate){
          this.loadingClear = true
          this.startDateFilter = startDate
          this.endDateFilter = endDate
          if(this.search == null){
            await this.fetchUsers()
          }else{
            await this.searchPeople(this.search)
          }
          this.loadingClear = false
        }
    }
}
</script>
